<template>
  <div class="imgMsg v-img">
    <a target="_blank" :href="data.filePath">
      <img :src="data.previewImageUrl" />
    </a>
  </div>
</template>

<script>

export default {
  props: ["data"],
  data() {
    return {};
  },
  computed: {},
  methods: {   
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Main/ChatMessageImage.vue